export const manageAncillaryAction = {
  MANAGE_SAVEANCILLARYDATA: "MANAGE_SAVEANCILLARYDATA",
  MANAGE_ADDBAG: "MANAGE_ADDBAGS",
  MANAGE_MINUSBAG: "MANAGE_MINUSBAG",
  MANAGE_INITIALIZESATE: "MANAGE_INITIALIZESATE",
  MANAGE_ADDTOCART: "MANAGE_ADDTOCART",
  MANAGE_REMOVEFROMCART: "MANAGE_REMOVEFROMCART",
};